import { FC, useMemo } from 'react'
import { InfoItem } from '@ui/drawer/common/infoItem'
import { DomainDetailList } from './DomainDetailList'
import { PrimaryGrid, Wrapper } from './assetInfoDomainDetails.styles'
import { AssetInfoDomainDetailsProps } from './assetInfoDomainDetails.types'
import {
    formatDateValue,
    formatOpenPort,
    getActiveCertificates,
    PLACEHOLDER,
} from './assetInfoDomainDetails.utils'

const AssetInfoDomainDetails: FC<AssetInfoDomainDetailsProps> = ({ asset }) => {
    const {
        hostname,
        isp,
        shared_ip: sharedIp,
        last_seen: lastSeen,
        ip,
        certificates,
        open_ports: openPorts,
    } = asset

    const ips = useMemo(() => ip ?? [], [ip])

    const activeCertificates = useMemo(
        () => getActiveCertificates(certificates?.[0]),
        [certificates]
    )
    const formattedPorts = useMemo(
        () => (openPorts ?? []).map(formatOpenPort),
        [openPorts]
    )

    return (
        <Wrapper>
            <PrimaryGrid>
                <InfoItem
                    title="Last detected"
                    dataTestId="domain-last-detected"
                >
                    {formatDateValue(lastSeen)}
                </InfoItem>
                <InfoItem
                    title="Host"
                    dataTestId={hostname ? 'hostname' : 'not-detected'}
                >
                    {hostname || PLACEHOLDER}
                </InfoItem>
                <InfoItem
                    title="ISP"
                    dataTestId={isp ? 'isp' : 'isp-not-detected'}
                >
                    {isp || PLACEHOLDER}
                </InfoItem>
                <InfoItem title="Shared IP" dataTestId="shared-ip">
                    {sharedIp ? 'Yes' : 'No'}
                </InfoItem>
            </PrimaryGrid>

            <DomainDetailList
                title="Associated IPs"
                items={ips}
                placeholder={PLACEHOLDER}
                testId="domain-associated-ips"
                itemTestId="domain-ip-item"
            />

            <DomainDetailList
                title="Certificates"
                items={activeCertificates}
                testId="domain-certificates"
                itemTestId="domain-certificate-item"
            />

            <DomainDetailList
                title="Open ports"
                items={formattedPorts}
                testId="domain-open-ports"
                itemTestId="domain-open-port-item"
            />
        </Wrapper>
    )
}

export default AssetInfoDomainDetails
